import { render, staticRenderFns } from "./ebs-lend.vue?vue&type=template&id=2a8279b1&"
import script from "./ebs-lend.vue?vue&type=script&lang=js&"
export * from "./ebs-lend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports